import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreakdownComponent } from '../../sections/breakdown/breakdown.component';
import { EmpowerComponent } from '../../sections/empower/empower.component';
import { ExploreComponent } from '../../sections/explore/explore.component';
import { HeroComponent } from '../../sections/hero/hero.component';
import { TopPartnersComponent } from '../../sections/top-partners/top-partners.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    TopPartnersComponent,
    ExploreComponent,
    BreakdownComponent,
    EmpowerComponent,
    HeroComponent
  ],
  providers: [DatePipe],
})

export class HomeModule { }
